// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"bb9f0334","81":"1d1196ce","200":"152663b2","496":"40aba15c","539":"58d7b91b"}[chunkId] + ".chunk.js";
};